import { IAppBrandPropTypes } from '@interfaces/interfaces'
import { Stack, Typography } from '@mui/material'
import React from 'react'

export const AppBrand: React.FunctionComponent<IAppBrandPropTypes> = ({
  title,
  icon,
}) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='flex-start'
      gap={4}
    >
      {icon}
      <Typography variant='h1' sx={{ fontSize: '2.5rem', fontWeight: 'bold' }}>{title}</Typography>
    </Stack>
  )
}
